var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('img',{attrs:{"src":"/img/logo.png","height":"150px","width":"200px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }